import React from "react";
import { Box, Typography } from "@mui/material";
import ArrowUpwardRoundedIcon from "@mui/icons-material/ArrowUpwardRounded";
import ArrowDownwardRoundedIcon from "@mui/icons-material/ArrowDownwardRounded";

// Ported verbatim from startup-web (views/performance/components/TrendIndicator.js).
export const TREND_COLORS = {
    up: "#12B76A",
    down: "#F04438",
    flat: "#667085",
};

// Small "▲ 1.4% vs Aug 25" style indicator shared by the summary cards and the
// Monthly Performance table cells.
const TrendIndicator = ({ change, suffix, size = "0.75rem", placeholder = "" }) => {
    if (!change) {
        if (!placeholder) return null;
        return (
            <Typography component="span" sx={{ fontSize: size, color: TREND_COLORS.flat }}>
                {placeholder}
            </Typography>
        );
    }

    const color = TREND_COLORS[change.direction] || TREND_COLORS.flat;
    const Arrow = change.direction === "down" ? ArrowDownwardRoundedIcon : ArrowUpwardRoundedIcon;

    return (
        <Box component="span" sx={{ display: "inline-flex", alignItems: "center", gap: "2px", whiteSpace: "nowrap" }}>
            {change.direction !== "flat" && (
                <Arrow sx={{ fontSize: `calc(${size} + 2px)`, color }} />
            )}
            <Typography component="span" sx={{ fontSize: size, fontWeight: 600, color }}>
                {change.text}
            </Typography>
            {suffix && (
                <Typography component="span" sx={{ fontSize: size, color: TREND_COLORS.flat, fontWeight: 400 }}>
                    {suffix}
                </Typography>
            )}
        </Box>
    );
};

export default TrendIndicator;
